import React, { Suspense, useEffect } from "react";
import { useGlobal } from "reactn";
import Header from "./avm/Header";
import Spinner from "./avm/Spinner";
import MainView from "./avm/MainView";
import PageFooter from "./avm/PageFooter";
import { restoreSession } from "../lib/session";
import config from "../config";
import getLogger from "../lib/debug-logger";
import { setGlobalValue } from "../lib/global-util";
import { getBodyClassSwappers } from "../lib/webapi";
import { storedDataExists, restoreStoredData } from "../lib/stored-data";

import "../styles/main.scss";

const log = getLogger("Avm", 1);

const [addBodyClass, restoreBodyClass] = getBodyClassSwappers("body-styled");

setGlobalValue("PAGE_NAME", "main");

if (!storedDataExists()) {
  addBodyClass();
}

const Avm = () => {
  const [addressLine] = useGlobal("ADDRESS_LINE"); // search address as street address string
  const [addressLegalLine] = useGlobal("ADDRESS_LEGAL_LINE"); // search address as object
  const [username] = useGlobal("USERNAME");

  useEffect(() => {
    log("Configuration", config); //--------------- log
    if (!username) {
      restoreSession();
    } else {
      restoreStoredData(); // if exists
    }
  }, [username]);

  // change body class for property view instead ofn search
  useEffect(() => {
    if (addressLine || addressLegalLine) restoreBodyClass(); // remove background, change layout
  }, [addressLine, addressLegalLine]);

  return (
    <Suspense fallback={<p>Loading...</p>}>
      <Spinner />
      <Header />
      <MainView />
      <PageFooter />
    </Suspense>
  );
};

export default Avm;
